@if (notifications$().length > 0) {
  <div class="lab-notifications" role="status" aria-live="polite">
    <div class="lab-notifications__list">
      @for (notification of notifications$(); track notification.id) {
        <div class="lab-notifications__item" [class.lab-notifications__item--closing]="notification.closing">
          <lab-notification
            [heading]="notification.heading"
            [mood]="notification.mood"
            [action]="notification.action"
            [dismissible]="notification.dismissible"
            (action)="doAction(notification.id)"
            (dismiss)="close(notification.id)"
          />
        </div>
      }
    </div>
  </div>
}
